import Container from 'react-bootstrap/Container';
import FeatureCard from '../molecules/FeatureCard';
import Reveal from '../atoms/Reveal';
import { objecoes } from '../content/site';

/** As quatro dúvidas que travam a decisão, respondidas direto, antes do preço.
 *  Reaproveita o `FeatureCard` sem ícone: aqui o argumento é a resposta curta,
 *  não uma ilustração do recurso. */
function ObjectionsSection() {
  return (
    <section className="section section--alt" id="duvidas">
      <Container className="shell">
        <div className="section-head section-head--center">
          <span className="section-kicker">Antes de decidir</span>
          <h2 className="section-title">As dúvidas que sempre aparecem primeiro</h2>
        </div>

        <div className="card-grid">
          {objecoes.map((item, i) => (
            <Reveal key={item.pergunta} stagger={i}>
              <FeatureCard titulo={item.pergunta} texto={item.resposta} />
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default ObjectionsSection;
